const r=r=>{try{return JSON.parse(r)}catch(r){return}};export{r as safelyParseJson};
